export class MaterialFactor {
  static ApiUrl = 'api/mooring-material-factor';

  Id: number;
  RopeFactor: number;
  SinkRopeFactor: number;
  StrapFactor: number;
  RopeWithKnotFactor: number;
  RopeWithKnotAccidentFactor: number;
  ChainFactor: number;
  ConnectingElementSteelFactor: number;
  SteelWireRopeFactor: number;
  ShackleFactor: number;
  MountainBoltAndDragAnchorFactor: number;
  IsDisabled: boolean;
}

export class MaterialFactorUpdateDto {
  Id: number;
  RopeFactor: number;
  RopeAccidentFactor: number;
  SinkRopeFactor: number;
  SinkRopeAccidentFactor: number;
  StrapFactor: number;
  StrapAccidentFactor: number;
  RopeWithKnotFactor: number;
  RopeWithKnotAccidentFactor: number;
  ChainFactor: number;
  ChainAccidentFactor: number;
  ConnectingElementSteelFactor: number;
  ConnectingElementSteelAccidentFactor: number;
  SteelWireRopeFactor: number;
  SteelWireRopeAccidentFactor: number;
  ShackleFactor: number;
  ShackleAccidentFactor: number;
  MountainBoltAndDragAnchorFactor: number;
  MountainBoltAndDragAnchorAccidentFactor: number;
  IsDisabled: boolean;
}
